import { createAction, props } from '@ngrx/store';
import { TableStorageActionModel } from '@models/common/table-storage-action.model';
import { CertificateHistoricalModel } from '@models/configuration/certificate-historical.model';

export const createCertificateHistorical = createAction(
    '[CertificateHistorical] Create CertificateHistorical',
    props<{ action: TableStorageActionModel<CertificateHistoricalModel> }>()
);

export const createCertificateHistoricalSuccess = createAction(
    '[CertificateHistorical] Create CertificateHistorical Success',
    props<{ CertificateHistorical: CertificateHistoricalModel }>()
);

export const searchCertificateHistoricals = createAction(
    '[CertificateHistoricals] Search CertificateHistoricals',
    props<{ action: TableStorageActionModel<CertificateHistoricalModel> }>()
);

export const searchCertificateHistoricalsSuccess = createAction(
    '[CertificateHistoricals] Search CertificateHistoricals Success',
    props<{ CertificateHistoricals: CertificateHistoricalModel[] }>()
);

export const updateCertificateHistorical = createAction(
    '[CertificateHistorical] Update CertificateHistorical',
    props<{ action: TableStorageActionModel<CertificateHistoricalModel> }>()
);

export const updateCertificateHistoricalSuccess = createAction(
    '[CertificateHistorical] Update CertificateHistorical Success',
    props<{ CertificateHistorical: CertificateHistoricalModel }>()
);

export const selectCertificateHistorical = createAction(
    '[CertificateHistorical] Select CertificateHistorical',
    props<{ CertificateHistorical: CertificateHistoricalModel }>()
);

export const deleteCertificateHistorical = createAction(
    '[CertificateHistorical] Delete CertificateHistorical',
    props<{ action: TableStorageActionModel<CertificateHistoricalModel> }>()
);

export const deleteCertificateHistoricalSuccess = createAction(
    '[CertificateHistorical] Delete CertificateHistorical Success',
    props<{ CertificateHistorical: CertificateHistoricalModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);